/**
 * Content Domain — Seeds Barrel Export (Lazy Loading)
 *
 * v2.0: Converted from static re-exports to dynamic import() loaders.
 * Each module's seeds are now a separate chunk, loaded on demand.
 * This removes ~200 JSON files from the initial bundle.
 *
 * Created in R29 (DDD Fase 3 — seeds barrel).
 * Migrated to lazy loading mei 2026 (Bundle Optimization Phase 2).
 * See docs/guides/HUMAN_REVIEW_GUIDE.md for review process.
 */

export type SeedModule = {
  module: string
  moduleCode: string
  version: string
  taxonomyVersion: string
  // Raw JSON question payloads — validated by normalizeSeedQuestion downstream
  questions: Array<Record<string, any>>
}

/**
 * Load all 10 module seed collections via dynamic import.
 * Each module becomes a separate bundle chunk.
 * Returns array of seed module data in deterministic order.
 */
export async function loadAllSeeds(): Promise<SeedModule[]> {
  const loaders = [
    import('./SWW').then((m) => m.default),
    import('./SPR').then((m) => m.default),
    import('./GET').then((m) => m.default),
    import('./REK').then((m) => m.default),
    import('./MET').then((m) => m.default),
    import('./TIJD').then((m) => m.default),
    import('./GELD').then((m) => m.default),
    import('./TOPO').then((m) => m.default),
    import('./TAA').then((m) => m.default),
    import('./STU').then((m) => m.default),
  ]
  const results = await Promise.all(loaders)
  return results as SeedModule[]
}

/**
 * Load a single module's seeds by module code.
 * Useful for future on-demand loading scenarios.
 */
export async function loadModuleSeeds(moduleCode: string): Promise<SeedModule> {
  switch (moduleCode) {
    case 'SWW':
      return (await import('./SWW')).default
    case 'SPR':
      return (await import('./SPR')).default
    case 'GET':
      return (await import('./GET')).default
    case 'REK':
      return (await import('./REK')).default
    case 'MET':
      return (await import('./MET')).default
    case 'TIJD':
      return (await import('./TIJD')).default
    case 'GELD':
      return (await import('./GELD')).default
    case 'TOPO':
      return (await import('./TOPO')).default
    case 'TAA':
      return (await import('./TAA')).default
    case 'STU':
      return (await import('./STU')).default
    default:
      throw new Error(`Unknown module code: ${moduleCode}`)
  }
}

// ── Legacy compatibility re-exports ──────────────────────────────────
// These are kept for any code that still imports seeds statically.
// They will be undefined until loadAllSeeds() completes.
// All production consumers should use the async loaders above.
export let seedSWW: SeedModule | undefined
export let seedSPR: SeedModule | undefined
export let seedGET: SeedModule | undefined
export let seedREK: SeedModule | undefined
export let seedMET: SeedModule | undefined
export let seedTIJD: SeedModule | undefined
export let seedGELD: SeedModule | undefined
export let seedTOPO: SeedModule | undefined
export let seedTAA: SeedModule | undefined
export let seedSTU: SeedModule | undefined

/**
 * Populate legacy exports after async load.
 * Called internally by initializeSeedCollections().
 */
export function _populateLegacyExports(seeds: SeedModule[]): void {
  for (const seed of seeds) {
    switch (seed.moduleCode) {
      case 'SWW':
        seedSWW = seed
        break
      case 'SPR':
        seedSPR = seed
        break
      case 'GET':
        seedGET = seed
        break
      case 'REK':
        seedREK = seed
        break
      case 'MET':
        seedMET = seed
        break
      case 'TIJD':
        seedTIJD = seed
        break
      case 'GELD':
        seedGELD = seed
        break
      case 'TOPO':
        seedTOPO = seed
        break
      case 'TAA':
        seedTAA = seed
        break
      case 'STU':
        seedSTU = seed
        break
    }
  }
}
